import React from 'react';
import PropTypes from 'prop-types';
import CrossSmall from 'jl-ui-kit/elements/icons/CrossSmall';

import styles from './typeahead-overlay.scss';

const TypeaheadOverlay = ({ onCloseButtonClick }) => (
  <>
    <div className={styles.transparentOverlay} />
    <div className={styles.whiteOverlay} />
    <button
      data-testid="close-expanded-search"
      className={styles.closeButton}
      onClick={onCloseButtonClick}
    >
      <CrossSmall className={styles.closeIcon} />
      <p>Close</p>
    </button>
  </>
);

TypeaheadOverlay.propTypes = {
  onCloseButtonClick: PropTypes.func.isRequired,
};

export default TypeaheadOverlay;
